import { FC, useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SelectProps, SelectValue } from "../../types/SelectProps";
import DropdownArrowSVG from "../svg/functional-icons/DropdownArrowSVG";
import CustomError from "./CustomError";
import { useClickOutOfElement } from "../../custom-hooks/base-hooks/useClickOutOfElement";

interface CustomDropdownProps {
    defaultValue?: SelectProps;
    data: SelectProps[];
    errorKey?: string;
    dropDownCallback: (value: SelectValue) => void;
    labelKey?: string;
    buttonClassName?: string;
    wrapperClassName?: string;
    dropdownClassName?: string;
    placeHolderKey?: string;
}

const CustomDropdown: FC<CustomDropdownProps> = (props) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [currentOption, setCurrentOption] = useState<SelectProps | undefined>(props.defaultValue);
    const dropDownRef = useRef();

    useClickOutOfElement(dropDownRef, () => setIsVisible(false));

    // Обновляем currentOption при изменении defaultValue
    useEffect(() => {
        if (props.defaultValue) {
            setCurrentOption(props.defaultValue);
        } else {
            setCurrentOption(undefined);
        }
    }, [props.defaultValue]);

    const dropDownHandler = (option: SelectProps) => {
        setCurrentOption(option);
        props.dropDownCallback(option.value);
        setIsVisible(false);
    };

    return (
        <div className={`relative ${props.wrapperClassName}`} ref={dropDownRef}>
            {props.labelKey && (
                <label className="block mb-2 text-lg font-semibold text-[#344054]" htmlFor={props.labelKey}>
                    {t(props.labelKey)}
                </label>
            )}
            <button
                id="dropdownDefaultButton"
                data-dropdown-toggle="dropdown"
                className={`flex justify-between items-center text-light-text-100 hover:dark:bg-dark-bg-900 dark:text-dark-text-100 bg-light-bg-200 dark:bg-dark-bg-700 border-2 border-light-border-100 dark:border-dark-border-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${props.buttonClassName}`}
                type="button"
                onClick={() => setIsVisible(!isVisible)}
            >
                <span>
                    {!currentOption || currentOption?.value.toString().length === 0
                        ? t(props.placeHolderKey)
                        : t(currentOption?.labelKey)}
                </span>
                <DropdownArrowSVG />
            </button>
            <div
                id="dropdown"
                className={`absolute z-10 rounded-lg shadow ${
                    isVisible ? "visible" : "hidden"
                } bg-light-bg-200 dark:bg-dark-bg-700 ${props.dropdownClassName}`}
            >
                <ul
                    className="py-2 text-sm overflow-auto text-light-text-100 dark:text-dark-text-100"
                    aria-labelledby="dropdownDefaultButton"
                >
                    {props.data.map((option) => (
                        <li onClick={() => dropDownHandler(option)} key={`li-custom-dropdown-${option.value}`}>
                            <a href="#" className="block px-4 py-2 hover:bg-gray-100 hover:dark:bg-dark-bg-900">
                                {t(option.labelKey)}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>

            <CustomError errorKey={props.errorKey} name="" />
        </div>
    );
};

export default CustomDropdown;
